import React from 'react'
import { Text } from "@vds/core";
import styled from 'styled-components';
import { TileContainer } from '@vds/tiles';
import { Grid, Row } from '@vds/grids';
import { MarginSpacerS,MarginSpacerM } from 'common/components/styleTag';

function ImageTile({ data, props }) {
    return (
        <>
            <StyledTileContainer
                padding='0px'
                aspectRatio='1:1'
                width='205px'
                height='450px'
            >
                <Grid>
                    <NoPadRow>
                        <DevicePicture
                            url={data?.backgroundImage}
                        ></DevicePicture>
                    </NoPadRow>
                    <Row>
                        <Text kind="title" size='small'>
                            <span dangerouslySetInnerHTML={{
                                __html: data.subText,
                            }} />
                            
                        </Text>
                    </Row>
                    <MarginSpacerS></MarginSpacerS>
                    <Row>
                        <Text kind="body" size="small">
                        <span dangerouslySetInnerHTML={{
                                __html: data.subTitle,
                            }} />
                        </Text>
                    </Row>
                </Grid>

            </StyledTileContainer>

        </>
    );
}

const DevicePicture = styled.div`
background-image: ${({ url }) => `url("${url}")`};
background-repeat: no-repeat;
height: 235px;
width: 100%;
`;
const StyledTileContainer = styled(TileContainer)`
display:table-row;
flex-direction:row;
padding:0px !important;
`;

const NoPadRow = styled(Row)`
padding-left:0px !important;
padding-right:0px !important;
`


export default ImageTile